import TrackingElement from '../../elements/tracking/TrackingElement';
import { defineElement } from '@webtides/element-js';
import toTrackableSearchProduct from '../../elements/tracking/transformer/toTrackableListItemProduct';
import { trackViewItemList } from '../../elements/tracking/events/trackViewItemList';

class SearchPageTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            this.$trackingTarget.addEventListener('PRODUCTS_CHANGED', ({ detail: products }) => {
                trackViewItemList(this.id, this.templateName, this.pageTitle, products, toTrackableSearchProduct);
            });
        }
    }

    properties() {
        return {
            id: '',
            pageTitle: '',
            templateName: '',
        };
    }

    getTrackingTarget() {
        return document.querySelector('search-page');
    }
}

defineElement('search-page-tracking', SearchPageTracking);
